import CryptoJS from 'crypto-js'

const { VUE_APP_APPID, VUE_APP_APPKEY, VUE_APP_POINT, VUE_APP_VERSION } = process.env
const sdk_ver = '1.0.1'
const app_ver = VUE_APP_VERSION
let timer = null

/**
 * 埋点
 * @type {burying} 方法名收
 */
const buryingpoint = async(params) => {
  const burying = JSON.stringify({
    appid: VUE_APP_APPID,
    sdk_ver: sdk_ver,
    app_ver: app_ver,
    channel: '0',
    device: { // 设备信息
      type: getPlatform(),
      model: getPlatform(),
      id: isMobile(),
      id1: '',
      id2: '',
      id3: '',
      os: browserRedirect(),
      width: window.innerWidth,
      height: window.innerHeight,
      lang: navigator.language
    },
    net_type: getNetworkType(),
    user: {
      id: String(params.uid)
    },
    event: {
      time: Date.now() / 1000 | 0,
      name: params.name,
      type: params.type
    },
    properities: params.properities, // 其他信息 string
  })
  const headers = objKeySort(burying)
  await ajax('post', `${VUE_APP_POINT}/v1/event`, burying, headers)
  timer = null
}
/** 防抖 */
const perTimeout = (params, time = 0) => {
  timer = window.setTimeout(() => {
    buryingpoint(params)
  }, time)
  return timer
}
export default (params, time) => {
  if (time) {
    if (!timer) {
      perTimeout(params, time)
    }
  } else {
    buryingpoint(params)
  }
}
function getPlatform() {
  var ua = navigator.userAgent
  if (ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1) {
    // 安卓设备
    return 'Android'
  } else if (ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1 || ua.indexOf('iPod') > -1) {
    // 苹果iOS设备
    return 'iOS'
  } else {
    return 'PC'
  }
}
/**
 * 判断是否是浏览器
 */
function isMobile() {
  let uuid996 = localStorage.getItem('uuid996')
  if (!uuid996) {
    uuid996 = guid()
    localStorage.setItem('uuid996', uuid996)
  }

  return uuid996
}
/**
 * UUID
 * 如果是浏览器或者是电脑用户就用本方法
 */
function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
/**
 * 取当前操作系统
 */
function browserRedirect() {
  var sUserAgent = navigator.userAgent
  var isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
  var isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
  if (isMac) return 'Mac'
  var isUnix = (navigator.platform === 'X11') && !isWin && !isMac
  if (isUnix) return 'Unix'
  var isLinux = (String(navigator.platform).indexOf('Linux') > -1)
  if (isLinux) return 'Linux'
  if (isWin) {
    var isWin2K = sUserAgent.indexOf('Windows NT 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1
    if (isWin2K) return 'Win2000'
    var isWinXP = sUserAgent.indexOf('Windows NT 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
    if (isWinXP) return 'WinXP'
    var isWin2003 = sUserAgent.indexOf('Windows NT 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1
    if (isWin2003) return 'Win2003'
    var isWinVista = sUserAgent.indexOf('Windows NT 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1
    if (isWinVista) return 'WinVista'
    var isWin7 = sUserAgent.indexOf('Windows NT 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1
    if (isWin7) return 'Win7'
    var isWin10 = sUserAgent.indexOf('Windows NT 10') > -1 || sUserAgent.indexOf('Windows 10') > -1
    if (isWin10) return 'Win10'
    var isWin11 = sUserAgent.indexOf('Windows NT 11') > -1 || sUserAgent.indexOf('Windows 11') > -1
    if (isWin11) return 'Win11'
  }
  return 'other'
}
/**
 * 取网络类型
 */
function getNetworkType() {
  var ua = navigator.userAgent
  var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other'
  networkStr = networkStr.toLowerCase().replace('nettype/', '')
  var networkType
  switch (networkStr) {
    case 'wifi': networkType = 'wifi'; break
    case '5g': networkType = '5G'; break
    case '4g': networkType = '4G'; break
    case '3g': networkType = '3G'; break
    case '3gnet': networkType = '3G'; break
    case '2g': networkType = '2G'; break
    default: networkType = 'UNKNOWN'
  }
  return networkType
}
/**
 * 封装ajax
 * @param method:请求的方式get还是post
 * @param url:请求的地址
 * @param params:发送的参数
 * @callback 返回响应调用的函数
 * */
function ajax(method, url, params, header) {
  var xhr = new XMLHttpRequest()
  xhr.open(method, url)
  Object.keys(header).forEach(key => {
    xhr.setRequestHeader(key, header[key])
  })
  if (method.toLowerCase() === 'get') { // 判断请求方式
    xhr.send(params)
  } else {
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send(params)
  }
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4 && xhr.status === 200) {
      // console.log(xhr.responseText);
    }
  }
}

/**
 * 随机16位
 * @returns {string}
 */
function getRamNumber() {
  var result = ''
  for (var i = 0; i < 16; i++) {
    result += Math.floor(Math.random() * 16).toString(16)// 获取0-15并通过toString转16进制
  }

  // 默认字母小写，手动转大写
  return result.toUpperCase()// 另toLowerCase()转小写
}
// 签名排序
function objKeySort(body) {
  // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  const headers = {
    'x-996sdk-appid': VUE_APP_APPID,
    'x-996sdk-algo': 'MD5',
    'x-996sdk-nonce': getRamNumber(),
    'x-996sdk-timestamp': Date.now() / 1000 | 0
  }
  const xargs = ['POST', '/v1/event']
  Object.keys(headers).sort().forEach(key => {
    xargs.push(key + '=' + headers[key])
  })
  xargs.push(body)
  xargs.push('key=' + VUE_APP_APPKEY)
  headers['x-996sdk-sign'] = CryptoJS.MD5(xargs.join('\n')).toString()
  return headers
}
